import { getTaskCodeLevel } from "./taskCodeUtils";

export const SCHEDULE_TASK_TYPES = [
  "engineering",
  "procurement",
  "fabrication",
  "itp",
];

export const normalizeTaskType = (value) =>
  String(value || "").trim().toLowerCase();

/** Task type used for API filtering; defaults to itp when tab type is omitted. */
export const resolveScheduleTaskType = (fixedType) => {
  const type = normalizeTaskType(fixedType);
  return SCHEDULE_TASK_TYPES.includes(type) ? type : "itp";
};

export const taskMatchesScheduleType = (task, scheduleType) =>
  normalizeTaskType(task?.type) === scheduleType;

/** Whether a task row should appear in module task tables (EMS, CMS, etc.). */
export const shouldShowInTaskTable = (task, scheduleType) => {
  const taskCode = String(task?.taskCode ?? "").trim();
  if (!taskCode) return false;
  if (!taskMatchesScheduleType(task, scheduleType)) return false;

  const level = getTaskCodeLevel(taskCode);

  if (scheduleType === "itp") {
    return level === 3;
  }

  // EMS / PMS / CMS: show 2-level group rows and 3+ level work items
  return level >= 2;
};

export const getInitialData = (fixedType) => ({
  task: "",
  taskCode: "",
  type: resolveScheduleTaskType(fixedType),
  task_members: [],
  priority: "Medium",
  startDate: "",
  endDate: "",
  targetDate: "",
  estimatedTime: 0,
  hours: 0,
  progress: 0,
  status: "Not Started",
  comments: [],
  attachment: "",
  resourceId: null,
  isNew: true,
});

export const normalizeItpTypeValue = (value) => {
  return String(value || "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .trim();
};

export const COMMON_ITP_TYPES = [
  "Documents Review and Approval",
  "Assembly and Testing",
  "Preparation for Shipment",
];

export const PRESSURE_ITP_TYPES = [
  "ASME Pressure Equipment Fabrication (Separate ITP will be provided if sub-contracted)",
  ...COMMON_ITP_TYPES,
].map(normalizeItpTypeValue);

export const PIPING_ITP_TYPES = [
  "Piping Fabrication",
  ...COMMON_ITP_TYPES,
].map(normalizeItpTypeValue);
